export const ShieldIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
			<path
				d="M36.6841 4.86334V15.3808C36.6841 31.4173 20.7193 37.6415 20.7193 37.6415L19.8421 38L18.9649 37.6415C18.9649 37.6415 3 31.4173 3 15.3808V4.86334C3 4.10394 3.29574 3.37563 3.82215 2.83865C4.34857 2.30167 5.06255 2 5.80701 2H33.8771C34.6216 2 35.3356 2.30167 35.862 2.83865C36.3884 3.37563 36.6841 4.10394 36.6841 4.86334Z"
				fill="#262A2F"
			/>
			<path
				d="M36.6846 15.3808V4.86334C36.6846 4.10394 36.3889 3.37563 35.8625 2.83865C35.336 2.30167 34.6221 2 33.8776 2H20.7197V37.6415C23.3829 36.7377 36.6846 31.4173 36.6846 15.3808Z"
				fill="url(#paint0_linear_169_240)"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.0035 19.7817L25.0007 13.0914C25.5346 12.4959 26.4566 12.4641 27.0302 13.0215C27.572 13.548 27.6016 14.4083 27.0974 14.9708L19.8106 23.0996C19.3798 23.5802 18.6272 23.5802 18.1964 23.0996L14.9026 19.4253C14.3984 18.8627 14.428 18.0024 14.9698 17.4759C15.5434 16.9185 16.4654 16.9503 16.9993 17.5458L19.0035 19.7817Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_169_240"
					x1="29.0005"
					y1="28.5"
					x2="37.0005"
					y2="-1.5"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#5C90FC" />
					<stop offset="1" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</svg>
	)
}
